import { LOGISTICS_DATAS } from "../../constants";
import { convertLogicticsName, formatDeliveryAddress } from "../../helpers";

//* ທີ່ຢູ່ປາຍທາງ ສຳລັບພິມບິນ — ໃຊ້ຮ່ວມກັນທຸກແບບບິນ
//*   1. ມີ orderDelivery (ລູກຄ້າເລືອກຂົນສົ່ງ / ຈອງແລ້ວ) → "ສາຂາ, ເມືອງ, ແຂວງ" ຈາກ receiver
//*   2. ບໍ່ມີ → addressCf (ທີ່ຢູ່ທີ່ພິມ ຫຼື ເລືອກໃນໜ້າສ້າງອໍເດີ) → destinationLogistic
export const billDestination = (item) => {
  const fromDelivery = item?.orderDelivery?.id
    ? formatDeliveryAddress(item?.orderDelivery?.receiver)
    : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ຊື່ຂົນສົ່ງ ສຳລັບພິມບິນ — ຈາກ orderDelivery ກ່ອນ, ບໍ່ມີ → ຊື່ທີ່ບັນທຶກໃນອໍເດີ (logistic)
//*   "ພິມທີ່ຢູ່ເອງ" ບໍ່ແມ່ນຊື່ຂົນສົ່ງ → ບໍ່ສະແດງ
export const billLogistic = (item) => {
  const key = item?.orderDelivery?.delivery;
  const fromDelivery = key ? LOGISTICS_DATAS?.[String(key).toLowerCase()]?.name || key : "";
  const name = fromDelivery || item?.logistic || "";
  return name === "ພິມທີ່ຢູ່ເອງ" || name === item?.addressCf ? "" : name;
};

//* ແຖວ "ທີ່ຢູ່" ຂອງຜູ້ຮັບ ໃນບິນຂົນສົ່ງ (ມີແຖວ "ສາຂາ" ແຍກຢູ່ແລ້ວ) → ບ້ານ, ເມືອງ, ແຂວງ ບໍ່ຊ້ຳສາຂາ
//*   ບໍ່ມີ orderDelivery → ໃຊ້ທີ່ຢູ່ໃນອໍເດີ (addressCf)
export const billReceiverAddress = (item) => {
  const r = item?.orderDelivery?.id ? item?.orderDelivery?.receiver : null;
  const fromDelivery = r ? [r.village, r.district, r.province].filter(Boolean).join(", ") : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ສາຂາປາຍທາງ ສຳລັບພິມບິນ
//*   1. ມີ orderDelivery → receiver.branch
//*   2. ບໍ່ມີ (ອໍເດີທີ່ຮ້ານສ້າງເອງ) → ສ່ວນ "ສາຂາ" ຂອງ addressCf ທີ່ບັນທຶກເປັນ "ສາຂາ, ເມືອງ, ແຂວງ"
//*      (ຮູບແບບດຽວກັບ DestinationPicker) — ສັ້ນກວ່າ 3 ສ່ວນ = ບໍ່ຮູ້ວ່າສ່ວນໃດເປັນສາຂາ → ວ່າງ
export const billReceiverBranch = (item) => {
  const fromDelivery = item?.orderDelivery?.receiver?.branch;
  if (fromDelivery) return fromDelivery;
  const parts = String(item?.addressCf || item?.destinationLogistic || "")
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
  return parts.length >= 3 ? parts.slice(0, -2).join(", ") : "";
};

//* ທີ່ຢູ່ຕົ້ນທາງທີ່ຮ້ານເລືອກໄວ້ (✓) ໃນໜ້າຕັ້ງຄ່າຂົນສົ່ງ ຂອງຂົນສົ່ງທີ່ເລືອກໃນອໍເດີ — ສຳລັບອໍເດີທີ່ບໍ່ມີ orderDelivery
//*   ໜຶ່ງຂົນສົ່ງມີ setDefault ໄດ້ອັນດຽວ (updateShopAddressDefault) → ບໍ່ມີ ✓ ເອົາອັນທຳອິດຂອງຂົນສົ່ງນັ້ນ
//*   ຊື່ຂົນສົ່ງໃນອໍເດີມີຫຼາຍແບບ (ອໍເດີເກົ່າສະກົດ "ຮຸງອາລູນ" ກໍມີ)
const LOGISTIC_TO_DELIVERY_NAME = {
  "ຮຸ່ງອາລຸນ": "HAL",
  "ຮຸງອາລູນ": "HAL",
  HAL: "HAL",
  "ມີໄຊ": "MIXAY",
  MIXAY: "MIXAY",
  "J&T Express": "JNT",
  "J&T": "JNT",
  JNT: "JNT",
  "ອານຸສິດ": "ANUSITH",
};

//* ລະຫັດຂົນສົ່ງ (HAL/MIXAY/JNT/ANUSITH) ສຳລັບໂລໂກ້/ຊື່ໃນບິນ
//*   ມີ orderDelivery → delivery ທີ່ຈອງ, ບໍ່ມີ (ອໍເດີທີ່ຮ້ານສ້າງເອງ) → ຈາກຊື່ຂົນສົ່ງທີ່ເລືອກໃນອໍເດີ
export const billDeliveryKey = (item) =>
  item?.orderDelivery?.delivery ||
  LOGISTIC_TO_DELIVERY_NAME[String(item?.logistic || "").trim()] ||
  "";

//* ຊື່ຂົນສົ່ງທີ່ຮ້ານພິມເອງ (ບໍ່ແມ່ນ HAL/MIXAY/JNT ທີ່ເຊື່ອມລະບົບ) — ບິນສະແດງຊື່ນີ້ແທນໂລໂກ້
//*   ຄືນ "" ເມື່ອຈອງຂົນສົ່ງແລ້ວ, ເລືອກຂົນສົ່ງທີ່ເຊື່ອມລະບົບ ຫຼື ບໍ່ໄດ້ພິມຊື່ (ຄ່າ placeholder ຂອງ DestinationPicker)
const INTEGRATED_DELIVERIES = ["HAL", "MIXAY", "JNT"];
const MANUAL_LOGISTIC_PLACEHOLDER = "ພິມທີ່ຢູ່ເອງ";
export const billManualCarrierName = (item) => {
  if (item?.orderDelivery?.delivery) return "";
  const name = String(item?.logistic || "").trim();
  if (!name || name === MANUAL_LOGISTIC_PLACEHOLDER) return "";
  return INTEGRATED_DELIVERIES.includes(LOGISTIC_TO_DELIVERY_NAME[name]) ? "" : name;
};
//* ຊື່ຂົນສົ່ງສຳລັບບິນ: ຊື່ທີ່ຮ້ານພິມເອງ ຫຼື ຊື່ຂອງຂົນສົ່ງທີ່ເຊື່ອມລະບົບ (ຮຸ່ງອາລຸນ/ມີໄຊ/J&T Express)
export const billCarrierName = (item) =>
  billManualCarrierName(item) || convertLogicticsName(billDeliveryKey(item)) || "";
export const billSelectedShopAddress = (item, shopAddresses) => {
  if (item?.orderDelivery?.id || !Array.isArray(shopAddresses)) return null;
  const deliveryName = LOGISTIC_TO_DELIVERY_NAME[String(item?.logistic || "").trim()];
  if (!deliveryName) return null;
  const list = shopAddresses.filter((a) => a?.deliveryName === deliveryName);
  return list.find((a) => a?.setDefault) || list[0] || null;
};

//* ຜູ້ຝາກ ສຳລັບພິມບິນ — ຂອງຮ້ານສະເໝີ
//*   1. ມີ orderDelivery → sender ທີ່ໃຊ້ຈອງຂົນສົ່ງ (ຂໍ້ມູນທີ່ຂົນສົ່ງໄດ້ຮັບແທ້)
//*   2. ບໍ່ມີ → ທີ່ຢູ່ຕົ້ນທາງທີ່ເລືອກໃນໜ້າຕັ້ງຄ່າຂົນສົ່ງ (billSelectedShopAddress)
//*   3. ບໍ່ມີທັງສອງ (ຂົນສົ່ງພິມເອງ) → ຂໍ້ມູນຮ້ານ (shopData)
export const billSenderName = (item, shopData, shopAddresses) =>
  item?.orderDelivery?.sender?.fullName ||
  billSelectedShopAddress(item, shopAddresses)?.fullName ||
  shopData?.name || item?.shop?.name || "";
export const billSenderTel = (item, shopData, shopAddresses) =>
  item?.orderDelivery?.sender?.tel ||
  billSelectedShopAddress(item, shopAddresses)?.shopTel ||
  shopData?.phone || item?.shop?.phone || "";
export const billSenderBranch = (item, shopData, shopAddresses) => {
  const addr = billSelectedShopAddress(item, shopAddresses);
  return (
    item?.orderDelivery?.sender?.branch ||
    addr?.branch || addr?.village ||
    shopData?.address?.village || ""
  );
};

//* ຜູ້ຮັບ ສຳລັບພິມບິນ — ບໍ່ມີ orderDelivery → ຂໍ້ມູນລູກຄ້າໃນອໍເດີ (ບໍ່ແມ່ນຂອງຮ້ານ)
export const billReceiverName = (item) =>
  item?.orderDelivery?.receiver?.fullName || item?.customerName || item?.cfName || "";
export const billReceiverTel = (item) =>
  item?.orderDelivery?.receiver?.tel || item?.phone || "";

//* ການເກັບເງິນ ສຳລັບພິມບິນ: FREE = ເກັບຄ່າຂົນສົ່ງຕົ້ນທາງ, CDC = ເກັບຄ່າຂົນສົ່ງປາຍທາງ, COD = ຄ່າຂົນສົ່ງ ແລະ ຄ່າເຄື່ອງປາຍທາງ
//*   1. ມີ orderDelivery → shipmentPayType ທີ່ຈອງໄວ້
//*   2. ບໍ່ມີ → ຈາກອໍເດີ (paymentType/paymentPlan/payment) ແບບດຽວກັບໜ້າສ້າງອໍເດີ (OrderAddV2)
export const billShipmentPayType = (item) => {
  if (item?.orderDelivery?.shipmentPayType) return item.orderDelivery.shipmentPayType;
  if (item?.paymentPlan === "COD" || item?.payment === "COD") return "COD";
  return item?.paymentType === "ORIGINAL" ? "FREE" : "CDC";
};

export const BILL_SHIPMENT_PAY_TYPE_LABEL = {
  FREE: "ເກັບເງິນຕົ້ນທາງ",
  CDC: "ເກັບເງິນປາຍທາງ",
  COD: "ເກັບຄ່າຂົນສົ່ງ ແລະ ຄ່າເຄື່ອງປາຍທາງ",
};

//* ລະຫັດ COD ທີ່ຮ້ານໃສ່ໃນອໍເດີ — ສະແດງສະເພາະຕອນເກັບປາຍທາງ (CDC/COD)
export const billCodNumber = (item) =>
  billShipmentPayType(item) === "FREE" ? "" : String(item?.codNumber || "").trim();

//* ຍອດ COD ໃນບິນ = ຄ່າສິນຄ້າ (ບໍ່ລວມຄ່າຂົນສົ່ງ) ທີ່ຂົນສົ່ງຕ້ອງເກັບຈາກລູກຄ້າ
//*   ເກັບຕົ້ນທາງ (FREE) → 0
//*   ເກັບປາຍທາງ (CDC) → ຄ່າສິນຄ້າ ສະເພາະທີ່ລູກຄ້າຍັງບໍ່ໄດ້ຈ່າຍ — ໂອນແລ້ວ (isPaymented) ເກັບແຕ່ຄ່າຂົນສົ່ງ → 0
//*   COD → ຄ່າສິນຄ້າ
export const billCodAmount = (item) => {
  const type = billShipmentPayType(item);
  if (type === "FREE" || (type === "CDC" && item?.isPaymented)) return 0;
  return Number(item?.orderDelivery?.totalParcel ?? item?.totalPrice ?? 0) || 0;
};

//* ເງິນລວມ ໃນບິນ = ຄ່າຂົນສົ່ງ (ຖ້າຮູ້) + ຍອດ COD — ໃຫ້ກົງກັບແຖວ ເງິນຝາກ ແລະ COD ທີ່ຢູ່ເທິງ
//*   ຄ່າຂົນສົ່ງ: ຈາກຂົນສົ່ງ (totalShippingFree) → ບໍ່ມີ → ຄ່າສົ່ງທີ່ຮ້ານໃສ່ໃນອໍເດີ (shipPrice)
export const billShippingFee = (item) =>
  Number(item?.orderDelivery?.totalShippingFree || item?.shipPrice || 0) || 0;
export const billTotalAmount = (item) => billShippingFee(item) + billCodAmount(item);

//* shipments ເປັນ JSON string ຈາກຂົນສົ່ງ — ອໍເດີທີ່ບໍ່ມີ orderDelivery ຈະບໍ່ມີ → ຢ່າໃຫ້ບິນພັງ
export const billShipments = (item) => {
  try {
    return JSON.parse(item?.orderDelivery?.shipments || "null") || {};
  } catch (e) {
    return {};
  }
};

//* ທີ່ຢູ່ຕົ້ນທາງ (ຜູ້ສົ່ງ) ສຳລັບພິມບິນ — ບ້ານ, ເມືອງ, ແຂວງ
//*   1. ມີ orderDelivery → ທີ່ຢູ່ຜູ້ສົ່ງທີ່ໃຊ້ຈອງຂົນສົ່ງ (sender)
//*   2. ບໍ່ມີ → ທີ່ຢູ່ຕົ້ນທາງທີ່ເລືອກໃນໜ້າຕັ້ງຄ່າຂົນສົ່ງ → ບໍ່ມີ → ທີ່ຢູ່ຂອງຮ້ານ (shopData.address)
export const billSenderAddress = (item, shopData, shopAddresses) => {
  const join = (a) => [a?.village, a?.district, a?.province].filter(Boolean).join(", ");
  const fromDelivery = item?.orderDelivery?.id ? join(item?.orderDelivery?.sender) : "";
  return (
    fromDelivery ||
    join(billSelectedShopAddress(item, shopAddresses)) ||
    join(shopData?.address) || ""
  );
};
